require('./bootstrap');
window.Vue = require('vue').default;
import moment from 'moment';
import Form from 'vform';
import Gate from "./gate";
import Swal from 'sweetalert2';
import VueProgressBar from 'vue-progressbar'
import VueRouter from 'vue-router';
import routes from './routes';
import VueI18n from 'vue-i18n'
import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';

window.Form = Form;
Vue.prototype.$gate = new Gate(window.user);

window.Swal = Swal;

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})
window.Toast = Toast;

Vue.use(VueProgressBar, {
    color: 'rgb(143, 255, 199)',
    failedColor: 'red',
    height: '3px'
});

Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('not-found', require('./components/NotFound.vue').default);

Vue.filter('dateFormat', function (created) {
    return moment(created).format('DD/MM/YYYY');
});
Vue.filter('yesno', value => (value ? '<i class="fas fa-check green"></i>' : '<i class="fas fa-times red"></i>'));

Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    base: '/rights-owners',
    routes
});

Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: 'en', // set locale
    messages: window.messages, // set locale messages
})

Vue.use(VueFileAgent)

// static vars, lits, properties.....
window.baseUrl = process.env.MIX_BASE_URL + process.env.MIX_API_VERSION + process.env.MIX_RIGHTS_OWNERS_BASE_URL

Vue.prototype.$baseUrl = window.baseUrl;
Vue.prototype.$countries = window.countries;
Vue.prototype.$genres = window.genres;
Vue.prototype.$tags = window.tags
Vue.prototype.$languages = window.languages
Vue.prototype.$aspect_ratio = window.aspect_ratio
Vue.prototype.$colorization = window.colorization
Vue.prototype.$audiences = window.audiences
Vue.prototype.$festivals = window.festivals
Vue.prototype.$rights_status = window.rights_status
Vue.prototype.$axios = window.axios

const app = new Vue({
    el: '#app',
    router,
    i18n
})
